export default __webpack_public_path__ + "static/media/Flag of Northern Mariana Islands.76cd45d8.gif";